import React from "react";
import { HashRouter } from "react-router-dom";
import { renderRoutes } from "react-router-config";
import { createBrowserHistory } from "history";

import { Provider as StoreProvider } from "react-redux";
import { configureStore } from "./store";

import routes from "./routes";

const history = createBrowserHistory();
const store = configureStore();

//const NODE_ENV = process.env.NODE_ENV;

const App = () => {
  // if (NODE_ENV !== "production") {
  //   const token =
  //     "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1aWQiOjIsImlhdCI6MTU5MDk1NDE4Mn0.nYva126bpdjlp8yQNgBWoyl0-7FvdzkO2zsxmyL3YfE";

  //   const user = {
  //     id: 2,
  //     username: "allandelivery@sandbox.pagseguro.com.br",
  //     name: "Allan Cerqueira de Carvalho",
  //     is_active: 1,
  //     dt_last_update_password: null,
  //     id_employee: 2,
  //     id_customer: 7,
  //     is_admin: 1,
  //     created_at: "2020-04-27 17:01:07",
  //     updated_at: "2020-04-27 17:01:07",
  //     password_expired: true,
  //   };

  //   localStorage.setItem(USER_KEY, JSON.stringify(user));
  //   localStorage.setItem(TOKEN_KEY, token);
  // }

  return (
    <StoreProvider store={store}>
      <HashRouter history={history}>{renderRoutes(routes)}</HashRouter>
    </StoreProvider>
  );
};

export default App;
